import React, { useState, useContext } from "react";
import { AppContext } from "../../utils/stateHandlers/contexts";
import { api } from "../../utils";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";

export default function UpdatePassword(props) {
  const { user } = useContext(AppContext);
  const [newPassword, setNewPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [passwordErrors, setPasswordErrors] = useState([]);

  const checkPasswordValidity = () => {
    const errors = [];

    if (newPassword !== confirmPassword) {
      errors.push("Passwords must match.");
    }

    const isNonWhiteSpace = /^\S*$/;
    if (!isNonWhiteSpace.test(newPassword)) {
      errors.push("Password cannot contain spaces.");
    }

    const isContainsUppercase = /^(?=.*[A-Z]).*$/;
    if (!isContainsUppercase.test(newPassword)) {
      errors.push("Password must have at least one Uppercase Character.");
    }

    const isContainsLowercase = /^(?=.*[a-z]).*$/;
    if (!isContainsLowercase.test(newPassword)) {
      errors.push("Password must have at least one Lowercase Character.");
    }

    const isContainsNumber = /^(?=.*[0-9]).*$/;
    if (!isContainsNumber.test(newPassword)) {
      errors.push("Password must contain at least one number.");
    }

    // const isContainsSymbol =
    //   /^(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹]).*$/;
    // if (!isContainsSymbol.test(newPassword)) {
    //   errors.push("Password must contain at least one Special Character.");
    // }

    const isValidLength = /^.{8,}$/;
    if (!isValidLength.test(newPassword)) {
      errors.push("Password must be 8 Characters Long.");
    }

    setPasswordErrors(errors);
    return errors.length > 0 ? false : true;
  };

  function updatePassword() {
    const validPassword = checkPasswordValidity();
    if (validPassword) {
      api.post("updatePassword", { password: newPassword }).then((res) => {
        user.signOut();
      });
    }
  }

  return (
    <Container maxWidth="sm">
      <Card>
        <CardHeader
          title={
            <Typography variant="articleTitle">Update Password</Typography>
          }
        />
        <CardContent>
          <Stack spacing={3}>
            <Typography variant="articleText" sx={{ marginBottom: "1rem" }}>
              Please enter a new password.
            </Typography>
            <Divider />
            <TextField
              required
              color="primary"
              type="password"
              onChange={(e) => setNewPassword(e.target.value)}
              label={<Typography variant="navText">New Password</Typography>}
              onBlur={() => checkPasswordValidity()}
            />
            <TextField
              required
              color="primary"
              type="password"
              onChange={(e) => setConfirmPassword(e.target.value)}
              label={
                <Typography variant="navText">Confirm Password</Typography>
              }
              onBlur={() => checkPasswordValidity()}
            />
            <Stack spacing={1}>
              {passwordErrors.length === 0 && (
                <Typography variant="subtitle2">
                  New Password must be at least 8 characters long.
                </Typography>
              )}

              {passwordErrors.map((error) => (
                <Typography key={error} variant="subtitle1">
                  {error}
                </Typography>
              ))}
            </Stack>
          </Stack>
        </CardContent>
        <CardActions>
          <Button
            size="small"
            color="success"
            variant="contained"
            onClick={() => updatePassword()}
            disabled={passwordErrors.length > 0 ? true : false}
          >
            Update Password
          </Button>
        </CardActions>
      </Card>
    </Container>
  );
}
